import { SpotMarketFilterAndSearch } from '../SpotMarketFilterAndSearch';
import { AssetFilter, ProductType } from 'src/hooks/useEarnProduct';
import Tabs from 'src/components/primitives/Tabs/Tabs';
import Select from 'src/components/primitives/Select/Select';
import { SelectOption } from 'src/components/primitives/Select/hooks/types';
import { WithClassName } from 'src/utils/UtilityTypes';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import { TabOption } from 'src/components/primitives/Tabs/types';
import useSelect from 'src/components/primitives/Select/hooks/useSelect';
import ScrollShadows from 'src/components/ScrollShadows';
import { useRef } from 'react';
import { cm } from 'src/utils/classNames';

interface SelectorsAndFiltersProps extends WithClassName {
	tabs: TabOption<AssetFilter>[];
	assetFilter: AssetFilter;
	onAssetFilterChange: (filter: AssetFilter) => void;
	productFilter: ProductType;
	setProductFilter: (filter: ProductType) => void;
	productFilterOptions: SelectOption<ProductType>[];
	searchInputValue: string;
	onSearchInputChange: (value: string) => void;
}

function SelectorsAndFilters({
	tabs,
	assetFilter,
	onAssetFilterChange,
	productFilter,
	setProductFilter,
	productFilterOptions,
	searchInputValue,
	onSearchInputChange,
	className,
}: SelectorsAndFiltersProps) {
	const isMobile = useIsMobileScreenSize();
	const scrollableTabsRef = useRef<HTMLDivElement>(null);

	const {
		selectOptions,
		selectedOption,
		value,
		onValueChange,
		open,
		onOpenChange,
	} = useSelect({
		selectedValue: productFilter,
		onSelectedValueChange: setProductFilter,
		options: productFilterOptions,
	});

	return (
		<div
			className={cm(
				'flex flex-col flex-wrap gap-md sm:flex-row sm:justify-between',
				className
			)}
		>
			<div className="w-full sm:w-fit">
				<ScrollShadows
					scrollableRef={scrollableTabsRef}
					gradientFromClassName="from-main-bg"
				>
					<div
						ref={scrollableTabsRef}
						className="hidden-scroll w-full overflow-auto bg-main-bg"
					>
						<Tabs
							variant="secondary"
							size={isMobile ? 'sm' : 'md'}
							options={tabs}
							activeTab={assetFilter}
							onTabChange={onAssetFilterChange}
							className="w-fit"
						/>
					</div>
				</ScrollShadows>
			</div>
			<div className="flex flex-col justify-end gap-lg sm:flex-row sm:gap-md">
				<Select.Root
					open={open}
					onOpenChange={onOpenChange}
					value={value}
					onValueChange={onValueChange}
				>
					<Select.Trigger
						label="Filter by Product"
						className="w-full min-w-[300px]"
					>
						{selectedOption?.label}
					</Select.Trigger>
					<Select.Options>
						{selectOptions.map((option) => (
							<Select.Option key={option.value} value={option.value}>
								{option.label}
							</Select.Option>
						))}
					</Select.Options>
				</Select.Root>

				<SpotMarketFilterAndSearch
					searchInputClassName="w-full"
					searchValue={searchInputValue}
					onSearch={onSearchInputChange}
					searchPlaceholder="Search Asset"
					needFilterWalletAssets={false}
					className="w-full"
				/>
			</div>
		</div>
	);
}

export default SelectorsAndFilters;
